{
  "title": "Mục mẫu",
  "subtitle": "Tính năng tham chiếu cho chuẩn frontend",
  "filters": {
    "status": "Trạng thái",
    "allStatuses": "Tất cả trạng thái"
  },
  "columns": {
    "name": "Tên",
    "price": "Giá",
    "status": "Trạng thái",
    "createdAt": "Ngày tạo"
  },
  "status": {
    "active": "Đang dùng",
    "archived": "Đã lưu trữ"
  },
  "fields": {
    "name": "Tên",
    "price": "Giá (USD)"
  },
  "list": {
    "empty": "Chưa có mục nào",
    "error": "Không tải được danh sách. Vui lòng thử lại.",
    "refreshing": "Đang làm mới"
  },
  "create": {
    "submit": "Thêm mục",
    "success": "Đã thêm mục",
    "error": "Không thêm được mục. Vui lòng thử lại."
  },
  "errors": {
    "TEMPLATE_ITEM_NAME_TAKEN": "Tên này đã được dùng",
    "REQUIRED": "Không được để trống",
    "INVALID_PRICE": "Nhập giá từ 0 trở lên"
  }
}
